/* tslint:disable */
/* eslint-disable */

import * as runtime from '../runtime';
import { HttpStatusCode } from 'axios';
import { BaseAPI } from '../baseApi';
import { Location } from '../types/Location';

export interface CreateLocationRequest {
  location: Location;
  supervisedTag?: string;
}
export interface GetAllLocationsRequest {
  supervisedTag?: string;
}
export interface GetLocationRequest {
  locationId: number;
  supervisedTag?: string;
}
export interface UpdateLocationRequest {
  location: Location;
  supervisedTag?: string;
}
export interface RemoveLocationRequest {
  locationId: number;
  supervisedTag?: string;
}

export class LocationApi extends BaseAPI {
  async createLocation(
    requestParameters: CreateLocationRequest,
  ): Promise<Location | runtime.ResponseError | undefined> {
    const headerParameters: runtime.HTTPHeaders = {};
    const queryParameters: any = {};
    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters.supervisedTag !== undefined) {
      queryParameters['supervisedTag'] = requestParameters.supervisedTag;
    }

    try {
      const response = await this.request({
        path: `/locations`,
        method: 'POST',
        headers: headerParameters,
        body: requestParameters.location,
        query: queryParameters,
      });

      return await new runtime.JSONApiResponse(
        response,
        (jsonValue): Location => jsonValue,
      ).value();
    } catch (error) {
      console.error('Error creating Location:', error);
      if (error instanceof runtime.ResponseError) {
        return error;
      }
    }
  }

  async getAllLocations(
    requestParameters: GetAllLocationsRequest,
  ): Promise<Array<Location> | runtime.ResponseError | undefined> {
    try {
      const queryParameters: any = {};

      if (requestParameters.supervisedTag !== undefined) {
        queryParameters['supervisedTag'] = requestParameters.supervisedTag;
      }

      const response = await this.request({
        path: `/locations`,
        method: 'GET',
        query: queryParameters,
      });

      return await new runtime.JSONApiResponse(
        response,
        (jsonValue): Array<Location> => jsonValue,
      ).value();
    } catch (error) {
      console.error('Error fetching Locations:', error);
      if (error instanceof runtime.ResponseError) {
        return error;
      }
    }
  }

  async getLocation(
    requestParameters: GetLocationRequest,
  ): Promise<Location | runtime.ResponseError | undefined> {
    try {
      const uri = encodeURIComponent(requestParameters.locationId);
      const queryParameters: any = {};

      if (requestParameters.supervisedTag !== undefined) {
        queryParameters['supervisedTag'] = requestParameters.supervisedTag;
      }

      const response = await this.request({
        path: `/locations/${uri}`,
        method: 'GET',
        query: queryParameters,
      });

      return await new runtime.JSONApiResponse(
        response,
        (jsonValue): Location => jsonValue,
      ).value();
    } catch (error) {
      console.error('Error fetching Location:', error);
      if (error instanceof runtime.ResponseError) {
        return error;
      }
    }
  }

  async updateLocation(
    requestParameters: UpdateLocationRequest,
  ): Promise<HttpStatusCode | runtime.ResponseError | undefined> {
    const headerParameters: runtime.HTTPHeaders = {};
    const queryParameters: any = {};
    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters.supervisedTag !== undefined) {
      queryParameters['supervisedTag'] = requestParameters.supervisedTag;
    }

    try {
      const response = await this.request({
        path: `/locations`,
        method: 'PUT',
        headers: headerParameters,
        body: requestParameters.location,
        query: queryParameters,
      });

      return response.status;
    } catch (error) {
      console.error('Error updating Location:', error);
      if (error instanceof runtime.ResponseError) {
        return error;
      }
    }
  }

  async removeLocation(
    requestParameters: RemoveLocationRequest,
  ): Promise<HttpStatusCode | runtime.ResponseError | undefined> {
    try {
      const uri = encodeURIComponent(requestParameters.locationId);
      const queryParameters: any = {};

      if (requestParameters.supervisedTag !== undefined) {
        queryParameters['supervisedTag'] = requestParameters.supervisedTag;
      }

      const response = await this.request({
        path: `/locations/${uri}`,
        method: 'DELETE',
        query: queryParameters,
      });

      return response.status;
    } catch (error) {
      console.error('Error removing Location:', error);
      if (error instanceof runtime.ResponseError) {
        return error;
      }
    }
  }
}
